import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Link from 'next/link';
import config from '../config';
import { getLatestNews } from '../api.services.js/others';
import Head from 'next/head';
import { Breadcrumb, BreadcrumbItem } from 'react-bootstrap';
export const getServerSideProps = async () => {
    const {data} = await getLatestNews({})
    return {
      props: {data :data.latest_news },
    };
  };

const Pressrelease = (props) => {

  const breadCrumbSchema = () => {
    return {
      __html: `{
        "@context": "https://schema.org/", 
        "@type": "BreadcrumbList", 
        "itemListElement": [{
          "@type": "ListItem", 
          "position": 1, 
          "name": "Home",
          "item": "https://www.orientbell.com"
        },{
        "@type": "ListItem", 
        "position": 2, 
        "name": "Latest News",
        "item": "https://www.orientbell.com/latest-news"
      }]
      }`
    }
  } 
  return (
    <>
    <Head>
      <title>Orientbell Tiles - Latest News</title>
      <meta name="title" content="Orientbell Tiles - Latest News"/>
<meta name="description" content="Orientbell News - Get the latest Orientbell news or announcements about offers, launch or innovation."/>
<meta name="keywords" content="orientbell event, orientbell latest event, orientbell upcoming event, orientbell events in india, obl events"/>
<script type="application/ld+json" dangerouslySetInnerHTML={ breadCrumbSchema()}/>
 </Head>
      <div className='Pressrelease_page'>
      <Container>
      <Breadcrumb>
        <BreadcrumbItem href='https://www.orientbell.com/'>Home</BreadcrumbItem>
        <BreadcrumbItem href='#'>Latest News</BreadcrumbItem>
        </Breadcrumb>
        <Row>
            <Col md={9}>
                <h1 className='productpage_title'>Media Coverage</h1>
                <p>Orientbell is making a name for itself. And our work is becoming the talk of the town.</p>
                <div className='Pressrelease_data'>
                    {props.data.latest_news.map((cur, index)=>{
                        return (
                            <div className='Pressrelease_card' key={index}>
                            <a href={`${config.HEADLESS_BASE_URL}/latestnews/post/${cur.postUrl.split("/")[2]}`} rel="nofollow">
                              <div className='Pressrelease_image'>
                              <img src={cur.img} alt='image'/>
                              </div>
                              <small>Date {cur.date}</small>
                              <p>{cur.title}</p>
                            </a>
                          </div>
                        )
                    })}
                  
                </div>
            </Col>
            <Col>
             <h5>Latest Announcements</h5>
             <div className='pressrelease_announcement'>
                {props.data.latest_announcement.map((cur, ind)=>{
                    return (
                        <div className='Pressrelease_card' key={ind}>
                          <a href={`${config.HEADLESS_BASE_URL}/${cur.postUrl}`} rel="nofollow">
                            <div className='Pressrelease_image'>
                              <img src={cur.img} alt='image'/>
                            </div>
                            <small>Date {cur.date}</small>
                            <p>{cur.title}</p>
                         </a>
                      </div>
                    )
                })}
             
             </div>
            </Col>
        </Row>
        </Container>
      </div>
    </>
  )
}

export default Pressrelease
